import { render } from "./Services.vue?vue&type=template&id=0553d8ea&scoped=true"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=0553d8ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0553d8ea"

export default script